import { createFileRoute } from '@tanstack/react-router';
import { PermissionGate } from '@/components/PermissionGate';
import { Permission } from '@/common/enums/permissions.enum';
import { AiAnalysisSettingsPage } from '@/features/ai-analysis/AiAnalysisSettingsPage';

export const Route = createFileRoute('/_authenticated/ai-analysis/settings')({
  component: AiAnalysisSettingsRoute,
});

function AiAnalysisSettingsRoute() {
  return (
    <PermissionGate permission={Permission.AI_ANALYSIS_MANAGE}>
      <AiAnalysisSettingsPage />
    </PermissionGate>
  );
}
